import { createStructuredSelector } from 'reselect'

import {
   EQUIPMENT_SCHEDULE_MAINTENANCE_LIST,
   EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_SUCCESS, 
   EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_ERROR,
   EQUIPMENT_SCHEDULE_MAINTENANCE_PAGE_SET,
   EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_SET,
   EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_CHANGE,
   EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT,
   EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
   EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR, 
   EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SET,
   EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_MODAL_SET,
   EQUIPMENT_SCHEDULE_MAINTENANCE_ADD,
   EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SUCCESS,
   EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_ERROR,
   EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_CHANGE,
   EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL,
   EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS,
   EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR,
   EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_MODAL_SET,
   EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_CHANGE,
   EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_MODAL_SET,
   EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE,
   EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_SUCCESS,
   EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_ERROR,
   EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_TAB_SET,
   EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET,
   EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_SUCCESS,
   EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_ERROR,
   EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_RESET
} from '../actions';

export const NAME = 'equipment_schedule_maintenance';

export const EquipmentScheduleMaintenanceList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EquipmentScheduleMaintenanceListSuccess = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_SUCCESS,
  payload: data
});

export const EquipmentScheduleMaintenanceListError = (error) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_LIST_ERROR,
  payload: error
});

export const EquipmentScheduleMaintenancePageSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_PAGE_SET,
  payload: data
});

export const EquipmentScheduleMaintenanceSearchSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_SET,
  payload: data
});

export const EquipmentScheduleMaintenanceSearchChangeSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_CHANGE,
  payload: data
});

export const EquipmentScheduleMaintenanceSearchDeliveryOrderLineLot = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT,
  payload: data
});

export const EquipmentScheduleMaintenanceSearchDeliveryOrderLineLotSuccess = (message) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  payload: message
});

export const EquipmentScheduleMaintenanceSearchDeliveryOrderLineLotError = (error) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  payload: error
}); 

export const EquipmentScheduleMaintenanceAddChangeSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_CHANGE,
  payload: data
});

export const EquipmentScheduleMaintenanceAddSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SET,
  payload: data
});

export const EquipmentScheduleMaintenanceAddModalSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_MODAL_SET,
  payload: data
});

export const EquipmentScheduleMaintenanceAdd = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD,
  payload: data
});

export const EquipmentScheduleMaintenanceAddSuccess = (message) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_SUCCESS,
  payload: message
});

export const EquipmentScheduleMaintenanceAddError = (error) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_ADD_ERROR,
  payload: error
});

export const RequestStatus = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL,
  payload: data
});

export const RequestStatusSuccess = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS,
  payload: data
});

export const RequestStatusError = (error) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR,
  payload: error
});

export const EquipmentScheduleMaintenanceViewModalSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_MODAL_SET,
  payload: data
});

export const EquipmentScheduleMaintenanceEditModalSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_MODAL_SET,
  payload: data
});

export const EquipmentScheduleMaintenanceEditChangeSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_EDIT_CHANGE,
  payload: data
});

export const EquipmentScheduleMaintenanceUpdate = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE,
  payload: data
});

export const EquipmentScheduleMaintenanceUpdateSuccess = (message) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_SUCCESS,
  payload: message.message
});

export const EquipmentScheduleMaintenanceUpdateError = (error) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_UPDATE_ERROR,
  payload: error
});

export const EquipmentScheduleMaintenanceViewTabSet = (data) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_VIEW_TAB_SET,
  payload: data
});

export const EquipmentScheduleMaintenanceUploadSet = (file) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET,
  payload: { file },
});

export const EquipmentScheduleMaintenanceUploadSetSuccess = (items) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const EquipmentScheduleMaintenanceUploadSetError = (error) => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_SET_ERROR,
  payload: error,
});

export const EquipmentScheduleMaintenanceUploadReset= () => ({
  type:  EQUIPMENT_SCHEDULE_MAINTENANCE_UPLOAD_RESET
});

const equipment_schedule_maintenance = (state) => state[NAME];

export const EquipmentScheduleMaintenanceSelector = createStructuredSelector({
  equipment_schedule_maintenance
})
 